import * as React from 'react'

interface ConditionalIconProps {
  color?: string
  gradient?: boolean
  width?: number
  height?: number
  alt?: string
}

const ConditionalIcon: React.FC<ConditionalIconProps> = ({
  color = '#888',
  gradient,
  width = 23,
  height = 20,
  alt = 'Conditional Icon',
}) => {
  const gradientColors = { start: '#ed1c24', end: '#27aae1' }

  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={width}
      height={height}
      fill='none'
      viewBox='0 0 23 20'
      aria-label={alt}
    >
      <title>{alt}</title>
      {gradient ? (
        <defs>
          <linearGradient id='grad1' x1='0%' y1='0%' x2='100%' y2='0%'>
            <stop offset='0%' style={{ stopColor: gradientColors.start, stopOpacity: 1 }} />
            <stop offset='100%' style={{ stopColor: gradientColors.end, stopOpacity: 1 }} />
          </linearGradient>
        </defs>
      ) : null}
      <path
        fill={gradient ? 'url(#grad1)' : color}
        fillRule='evenodd'
        d='M23.843.415a.625.625 0 0 1 0 .884l-4.546 4.546-.883-.884L22.959.415a.625.625 0 0 1 .884 0M.375 9.429c0-.345.28-.625.625-.625h6.429v1.25H1a.625.625 0 0 1-.625-.625'
        clipRule='evenodd'
      ></path>
      <path
        fill={gradient ? 'url(#grad1)' : color}
        fillRule='evenodd'
        d='M15.215 2.41 8.196 9.43l7.019 7.018 7.018-7.018zm.707-1.06a1 1 0 0 0-1.414 0L7.136 8.722a1 1 0 0 0 0 1.414l7.372 7.372a1 1 0 0 0 1.414 0l7.372-7.372a1 1 0 0 0 0-1.414z'
        clipRule='evenodd'
      ></path>
      <path
        fill={gradient ? 'url(#grad1)' : color}
        fillRule='evenodd'
        d='M23.844 19.559a.625.625 0 0 1-.884 0l-4.545-4.546.884-.883 4.545 4.545a.625.625 0 0 1 0 .884'
        clipRule='evenodd'
      ></path>
    </svg>
  )
}

export default ConditionalIcon
